import * as React from 'react';
import * as Redux from 'redux';
import * as action from '../../../search-page/actions/index'
import { IState } from '../../../header/reducers/index';
import { connect } from 'react-redux';
import { getAutocompleteResults } from '../../../search-page/actions/autocomplete-results'
import { SearchBar, ConnectedSearchBar } from '../inputs/search-bar/search-bar';
import * as _ from 'lodash';

interface IHeaderSearchBarProps extends IState {
    id: string;
    customClasses: string;
}

export class HeaderSearchBar extends React.Component<IHeaderSearchBarProps, any> {

    searchRedirect(term: string) {
        window.location.href = (window as any).searchBox.vertexSearchPageUrl + '?k=' + term;
    }

    shopSearchRedirect(term: string) {
        window.location.href = (window as any).searchBox.vertexSearchPageUrl + '?k=' + term + '&context=shopAAP';
    }

    render() {
        const anyWindow = window as any;
        const searchButtonText = anyWindow.searchBox && anyWindow.searchBox.searchButtonText;
        let searchBoxText = anyWindow.searchBox && anyWindow.searchBox.searchBoxText;
        let searchFunction = (val) => {
            this.props.dispatch(action.setSearchTerm(val));
            this.searchRedirect(val);
        }
        if (this.props.id == "shop-header-search-bar") {
            searchBoxText = anyWindow.searchBox && anyWindow.searchBox.shopSearchBoxText;
            searchFunction = (val) => {
                this.props.dispatch(action.setSearchTerm(val));
                this.shopSearchRedirect(val);
            }
        }
        return (
            <ConnectedSearchBar
                searchValue={this.props.searchTermModel}
                autocompleteModel={this.props.autocompleteModel}
                onChange={(val, setAutocompleteResults) => {
                    this.props.dispatch(action.setSearchTerm(val));
                    getAutocompleteResults(val, (data) => setAutocompleteResults(data.hits.map((hit) => hit.query)));
                }}
                onSearch={searchFunction}
                charsForAutocomplete={3}
                searchButtonText={searchButtonText}
                placeHolder={searchBoxText}
                id={this.props.id}
                customClasses={this.props.customClasses}
                searchBoxText={searchBoxText}
            />

        );
    }
}

// These are difficult to test due to tight coupling with redux
export const SearchBarComponent = connect(
    (state: IState) => {
        let props: IHeaderSearchBarProps = _.assign({}, state,
            { id: "global-header-search-bar", customClasses: "global-header-search-bar"}
        );
        return props;
    }
)(HeaderSearchBar);

export const MobileSearchBarComponent = connect(
    (state: IState) => {
        let props: IHeaderSearchBarProps = _.assign({}, state,
            { id: "mobile-header-search-bar", customClasses: "global-header-search-bar" }
        );
        return props;
    }
)(HeaderSearchBar);

export const ShopSearchBarComponent = connect(
    (state: IState) => {
        let props: IHeaderSearchBarProps = _.assign({}, state,
            { id: "shop-header-search-bar", customClasses:"shop-header-search-bar" }
        );
        return props;
    }
)(HeaderSearchBar);